export default "__VITE_ASSET__7a96gxmC__ 584w";